var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#4b4b4b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-calendar-check2-icon lucide-calendar-check-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10h18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16 20 2 2 4-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleDark);
export default __webpack_public_path__ + "static/media/schedule_dark.2122a27df9427f4697f574eb9bf18152.svg";
export { ForwardRef as ReactComponent };